import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { Kit } from 'src/app/models/kit';
import { GlobalService } from 'src/app/services/global.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { KitService } from 'src/app/services/kit.service';
import { KitComposicao } from 'src/app/models/kit-composicao';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import swal from 'sweetalert2';

@Component({
  selector: 'app-composicao-kit-automatico-modal',
  templateUrl: './composicao-kit-automatico-modal.component.html',
  styleUrls: ['./composicao-kit-automatico-modal.component.scss']
})
export class ComposicaoKitAutomaticoModalComponent implements OnInit {
  kit: Kit = new Kit();
  composicao: KitComposicao[] = [];
  integrador = false;
  mostrarCodErp = false;
  mostrarObsNoItem = false;
  mostrarValores = false;
  mostrarBifasico = false;
  permissoesPedidoFuncionario = { podeEditarFrete: false, podeEditarServicoEntrega: false, podeEditarSeguro: false, podeDescontoIndividual: false, podeVerTotaisMonitores: false };

  tipo = 0;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<ComposicaoKitAutomaticoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private funcionarioService: FuncionarioService,
    private premissasService: PremissasService,
    private kitService: KitService
  ) {
    this.kit = data.kit;
    this.tipo = data.tipo;
  }

  async ngOnInit(): Promise<void> {
    this.integrador = await this.globalService.integrador();

    if (!this.integrador) {
      await this.buscarPermissoesFuncionario();
    }

    this.buscarMostrarBifasico();

    await this.buscarMostrarCodErp();
    await this.buscarObsNoItem();
    await this.buscarVerPrecosProdutos();

    this.buscarComposicao();

  }

  buscarMostrarBifasico() {
    this.carregandoService.mostra('buscarMostrarBifasico');
    this.premissasService.consultarMostrarBifasico().subscribe(f => {
      this.mostrarBifasico = f.valor;
      this.carregandoService.esconde('buscarMostrarBifasico');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarBifasico');
      this.notificacaoService.erro(erro);
    });
  }

  buscarComposicao() {

    if (this.tipo === 0) {
      this.composicao = this.kit.composicao;
    } else {
      this.carregandoService.mostra('buscarComposicao');
      this.kitService.consultarComposicao(this.kit).subscribe((f: KitComposicao[]) => {
        this.composicao = f;
        this.carregandoService.esconde('buscarComposicao');
      }, (erro) => {
        this.carregandoService.esconde('buscarComposicao');
        this.notificacaoService.erro(erro);
      });
    }
  }

  retornaClasseTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'badge-primary';
      case '3':
        return 'badge-secondary';
      case '4':
        return 'badge-success';
      case '5':
        return 'badge-danger';
      case '6':
        return 'badge-dark';
      case '1':
        return 'badge-info';
      case '8':
        return 'badge-warning';
      case '9':
        return 'badge-danger';

      default:
        return 'badge-info';
    }
  }

  retornaLetraTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 'P';
      case '3':
        return 'I';
      case '4':
        return 'S';
      case '5':
        return 'C';
      case '6':
        return 'E';
      case '1':
        return 'O';
      case '7':
        return 'K';
      case '8':
        return 'T';
      case '9':
        return 'B';

      default:
        return 'O';
    }
  }

  retornaOrdemTipoProduto(tipo) {
    switch (tipo.toString()) {
      case '2':
        return 0;
      case '3':
        return 1;
      case '4':
        return 2;
      case '5':
        return 3;
      case '6':
        return 4;
      case '1':
        return 5;

      default:
        return 5;
    }
  }

  buscarVerPrecosProdutos() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarVerPrecosProdutos');
      this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
        this.mostrarValores = f.valor;
        this.carregandoService.esconde('buscarVerPrecosProdutos');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarVerPrecosProdutos');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  buscarMostrarCodErp() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarMostrarCodErp');
      this.premissasService.consultarMostrarCodErp().subscribe(f => {
        this.mostrarCodErp = f.valor;
        this.carregandoService.esconde('buscarMostrarCodErp');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarMostrarCodErp');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  buscarObsNoItem() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarObsNoItem');
      this.premissasService.consultarObsNoItem().subscribe(f => {
        this.mostrarObsNoItem = f.valor;
        this.carregandoService.esconde('buscarObsNoItem');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarObsNoItem');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  buscarPermissoesFuncionario() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarPermissoesFuncionario');
      this.funcionarioService.consultarPermissoesPedido().subscribe(f => {
        this.permissoesPedidoFuncionario = f;

        this.carregandoService.esconde('buscarPermissoesFuncionario');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarPermissoesFuncionario');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  atualizaValorProduto(item: KitComposicao) {
    if (item.qtd != null && item.qtd != undefined && Number(item.qtd) > 0) {
      item.valorTotal = Number((Number(item.qtd) * item.preco).toFixed(2));
      this.atualizaValorTotal();
    }
  }

  atualizaValorTotal() {
    this.kit.valorAtualizado = 0;
    this.kit.valorCusto = 0;

    this.composicao.forEach(c => {
      this.kit.valorAtualizado += c.valorTotal;
      this.kit.valorCusto += Number((c.precoCusto * c.qtd).toFixed(2));

      if (c.familia === 2) {
        this.kit.potenciaReal = c.potencia * c.qtd / 1000;
        this.kit.potencia = Math.floor(this.kit.potenciaReal);
      }
    });

    this.kit.valorAplicado = this.kit.valorAtualizado + ((this.kit.valorAtualizado * this.kit.da) / 100);
  }

  validaQtd(item: KitComposicao) {
    if (item.qtd === null || item.qtd === undefined || Number(item.qtd) < 0) {
      item.qtd = 1;
      this.atualizaValorProduto(item);
    }
  }

  excluirItem(item: KitComposicao) {

    if (item.familia === 2 || item.familia === 3) {
      return;
    }

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir esse item?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.composicao.splice(this.composicao.indexOf(item), 1);
        this.atualizaValorTotal();
      }
    });
  }

  salvar() {
    this.dialogRef.close(this.kit);
  }

  fechar() {
    this.dialogRef.close();
  }
}
